import { WriteMethodTypeValue } from "../../../domain/format/WriteMethodTypes";

export interface IFormatListSelectorDialogCondition {
  name: string;
  containsExpired: boolean;
  containsDeleted: boolean;
  shouldIgnoreChained: boolean;
  defaultWriteMethodTypes?: WriteMethodTypeValue[];
  shouldIncludeReferenceableGroupFormats?: boolean;
}

export function instanceOfIFormatListSelectorDialogCondition(instance: any): instance is IFormatListSelectorDialogCondition {
  return instance
    && (instance.name !== undefined)
    && (instance.containsExpired !== undefined)
    && (instance.containsDeleted !== undefined)
    && (instance.shouldIgnoreChained !== undefined);
}
